import React, { useState, useCallback } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "0.5rem",
};

const Map = ({ address }) => {
  const [coordinates, setCoordinates] = useState(null);
  const [mapError, setMapError] = useState(null);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAX7GkprjANsYgpBUKa6uS17cbziE9Zv4s",
    libraries: ["places"],
  });

  // Adresi koordinatlara çevir
  const geocodeAddress = useCallback(async () => {
    if (!address) return;

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          address
        )}&key=AIzaSyAX7GkprjANsYgpBUKa6uS17cbziE9Zv4s`
      );
      const data = await response.json();

      if (data.status === "OK" && data.results && data.results[0]) {
        const { lat, lng } = data.results[0].geometry.location;
        setCoordinates({ lat, lng });
        setMapError(null);
      } else {
        setMapError("Adres bulunamadı");
      }
    } catch (error) {
      console.error("Geocoding error:", error);
      setMapError("Konum bilgisi alınamadı");
    }
  }, [address]);

  // Harita yüklendiğinde adresi koordinatlara çevir
  React.useEffect(() => {
    if (isLoaded) {
      geocodeAddress();
    }
  }, [isLoaded, geocodeAddress]);

  // Haritaya tıklandığında yönlendirme yap
  const handleMarkerClick = () => {
    if (coordinates) {
      const encodedAddress = encodeURIComponent(address);

      // Check if the device is mobile
      if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
        // For iOS devices
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          window.location.href = `maps://maps.google.com/maps?daddr=${encodedAddress}&ll=${coordinates.lat},${coordinates.lng}`;
        }
        // For Android devices
        else {
          window.location.href = `geo:0,0?q=${coordinates.lat},${coordinates.lng}(${encodedAddress})`;
        }
      } else {
        // Desktop devices
        window.open(
          `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`,
          "_blank"
        );
      }
    }
  };

  if (loadError) {
    return (
      <div className='p-4 text-red-600 bg-red-100 rounded-lg'>
        Harita yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div className='p-4 text-gray-600 bg-gray-100 rounded-lg flex items-center justify-center h-[400px]'>
        <div className='animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500'></div>
      </div>
    );
  }

  if (mapError) {
    return (
      <div className='p-4 text-yellow-600 bg-yellow-100 rounded-lg'>
        {mapError}
      </div>
    );
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={coordinates || { lat: 41.0082, lng: 28.9784 }} // Default: Istanbul
      zoom={15}>
      {coordinates && (
        <Marker
          position={coordinates}
          onClick={handleMarkerClick}
          title='Click for directions'
        />
      )}
    </GoogleMap>
  );
};

export default Map;
